import React, { useState } from "react";
import {ProfileModel} from "../../features/profile/profileTypes";
import {useFormErrors} from "../../features/formErrors/formErrors";
import ImageCropper from "../ImageCropper/ImageCropper";
import {useUpdateUserAvatar} from "../../features/profile/profileApi";
import toast from "react-hot-toast";

type Props = {
    profile: ProfileModel;
}

const AvatarElement = ({profile}: Props) => {
    const {mutate: updateAvatar} = useUpdateUserAvatar();
    const {handleError, clearErrors, renderError} = useFormErrors();
    const [avatarEdit, setAvatarEdit] = useState<boolean>(false);

    const onAvatarCropApplied = (image: Blob, filename: string, type: string) => {
        updateAvatar({avatar: new File([image], filename, {type: type})}, {
            onError: handleError,
            onSuccess: () => {
                toast.success('Avatar updated');
                setAvatarEdit(false);
            },
        });
    };

    const handleCropCancel = () => {
        setAvatarEdit(false);
    }

    return (
        <>
            {!avatarEdit &&
                <>
                    <label className="form-label">Avatar</label>
                    <div>
                        <img width='400' height='400' className='img-fluid rounded-circle' src={profile.avatar} alt='avatar'/>
                    </div>
                    <button className='btn btn-sm btn-primary mt-1 slide-top' type='button' onClick={() => {
                        setAvatarEdit(true)
                    }}>EDIT AVATAR
                    </button>
                    {renderError("avatar")}
                </>
            }

            {avatarEdit &&
                <>
                    <label className="form-label">Avatar</label>
                    <ImageCropper image={profile.avatar} aspect={1} cropShape='round' onCropApplied={onAvatarCropApplied}
                                  onCancel={handleCropCancel}/>
                    {renderError("avatar")}
                </>
            }
        </>
    );
};

export default AvatarElement;
